"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/label-has-for */
const react_1 = __importDefault(require("react"));
function InputMetaWrapper(Component) {
    function InputMeta(props) {
        const { label, id, isRequired, isReadOnly, validationErrors } = props;
        return (react_1.default.createElement("div", { className: "input-field" },
            label && react_1.default.createElement("label", { htmlFor: id }, label),
            react_1.default.createElement(Component, { ...props }),
            isRequired && react_1.default.createElement("span", null, "* required"),
            isReadOnly && react_1.default.createElement("span", null, "* read only"),
            validationErrors.length > 0 && (react_1.default.createElement("ul", null, validationErrors.map(({ message }) => (react_1.default.createElement("li", { key: message }, message)))))));
    }
    InputMeta.displayName = `InputMeta(${Component.displayName ||
        Component.name})`;
    return InputMeta;
}
exports.default = InputMetaWrapper;
//# sourceMappingURL=InputMetaWrapper.js.map